const home = {
  anJun: {
    zh: '安骏跨境物流系统',
    en: '',
    pu: 'Sistema Logístico Cross Border de Anjun'
  },
  welcomeAnJun: {
    zh: '欢迎使用安骏跨境物流系统',
    en: '',
    pu: 'Bem-vindo ao Sistema Logístico Cross Border de Anjun'
  },
  welcomeanjunKD: {
    zh: '欢迎使用安骏快递系统',
    en: '',
    pu: 'Bem-vindo ao Sistema Anjun Express'
  },
  brazilOrder: {
    zh: '巴西本地快递下单',
    en: '',
    pu: 'Fazer pedido por Express local do Brasil '
  },
  test: {
    zh: '请输入旧密码',
    en: '',
    pu: 'Favor digitar a senha antiga'
  },
  coverCountry: {
    zh: '覆盖巴西全国地区',
    en: '',
    pu: 'Cobrir todo o Brasil'
  },
  placeOrder: {
    zh: '立即下单',
    en: '',
    pu: 'Fazer pedido agora'
  },
  finalState: {
    zh: '最终状态',
    en: '',
    pu: 'Estado final'
  },
  failNode: {
    zh: '推送失败节点',
    en: '',
    pu: 'Nó de envio falhado'
  },
  inputFiller: {
    zh: '输入关键字进行过滤',
    en: '',
    pu: 'Digite palavras-chave para filtrar'
  },
  configInfo: {
    zh: '配置信息',
    en: '',
    pu: 'Informações de configuração'
  },
  initNumber: {
    zh: '初始数量',
    en: '',
    pu: 'Número inicial'
  },
  minlimitcount: {
    zh: '最小限制数',
    en: '',
    pu: 'Número mínimo de limites'
  },
  maxLimitcount: {
    zh: '最大限制数',
    en: '',
    pu: 'Limite máximo'
  },
  balanceCount: {
    zh: '结余总数量',
    en: '',
    pu: 'Saldo total'
  },
  tip01: {
    zh: '最小限制不能大于等于最大限制数',
    en: '',
    pu: 'O limite mínimo não pode ser maior ou igual ao limite máximo'
  },
  limitMaxNumber: {
    zh: '超过最大限制数',
    en: '',
    pu: 'Limite máximo excedido'
  },
  limitMinxNumber: {
    zh: '低于最小限制数',
    en: '',
    pu: 'Abaixo do limite mínimo'
  },
  returnToRegistration: {
    zh: '返回登记',
    en: '',
    pu: 'Retornar ao registro'
  },
  huiRegistration: {
    zh: '回收登记',
    en: '',
    pu: 'Registro de reciclagem'
  },
  urgeRecovery: {
    zh: '催回收',
    en: '',
    pu: 'Acelerar a recuperação de algo'
  },
  clickException: {
    zh: '异常调整',
    en: '',
    pu: 'Ajuste de exceção'
  },
  registerCount: {
    zh: '返回数量',
    en: '',
    pu: 'Número de devoluções'
  },
  homeCount: {
    zh: '数量',
    en: '',
    pu: 'Quantidades'
  },
  tip02: {
    zh: '说明：输入负数，减少结余总数量；输入正数，增加结余总数量',
    en: '',
    pu: 'Observação: digite um número negativo para diminuir o saldo total; digite um número positivo para aumentar o saldo total.'
  },
  operationTotal: {
    zh: '操作总数',
    en: '',
    pu: 'Número total de operações'
  },
  siteType: {
    zh: '网点类型',
    en: '',
    pu: 'Tipe de ponto'
  },
  tip03: {
    zh: '确认返回数量不能大于应返回数量',
    en: '',
    pu: 'Confirmação de que a quantidade devolvida não pode ser maior do que a quantidade a ser devolvida'
  },
  lijiReturn: {
    zh: '立即前往返回',
    en: '',
    pu: 'Voltar agora'
  },
  inputNumberdayu0: {
    zh: '输入大于零的整数',
    en: '',
    pu: 'Digite um número inteiro maior que zero'
  },
  uploadTime: {
    zh: '上传时间',
    en: '',
    pu: 'Tempo de carregamento'
  },
  applivefail: {
    zh: '审核失败',
    en: '',
    pu: 'Análise encerrada'
  },
  clickSee: {
    zh: '点击查看',
    en: '',
    pu: 'Visualizar'
  },
  qiangzhiApplive: {
    zh: '强制签收审核',
    en: '',
    pu: 'Auditoria de Pacotes'
  },
  seesingPhoto: {
    zh: '查看签收照片',
    en: '',
    pu: 'Ver fotografias assinadas'
  },
  ViewSignature: {
    zh: '查看签收签名',
    en: '',
    pu: 'Ver assinatura'
  },
  signedPhoto: {
    zh: '签收拍照',
    en: '',
    pu: 'Assinatura e fotografia'
  },
  signedNamePhoto: {
    zh: '签收签名',
    en: '',
    pu: 'Assinatura'
  },
  appliveResult: {
    zh: '审核结果',
    en: '',
    pu: 'Resultados da auditoria'
  },
  pass: {
    zh: '通过',
    en: '',
    pu: 'Aprovar'
  },
  noPass: {
    zh: '不通过',
    en: '',
    pu: 'Falhar'
  },
  unapplivefail: {
    zh: '审核未通过',
    en: '',
    pu: 'Análise reprovado'
  },
  photoStandard: {
    zh: '照片不合格',
    en: '',
    pu: 'Foto não conforme'
  },
  signStandard: {
    zh: '签名不合格',
    en: '',
    pu: 'Assinatura não conforme'
  },
  tip1002: {
    zh: '请选择不通过原因',
    en: '',
    pu: 'Por favor, selecione o motivo da não aprovação'
  },
  batchConfiguration: {
    zh: '批量配置',
    en: '',
    pu: 'Configuração em lote'
  },
  justSearchConditionCenter: {
    zh: '仅查询下属中心',
    en: '',
    pu: 'Query Only Subordinate Centers'
  },
  batchConfigurationSite: {
    zh: '仅查下属网点',
    en: '',
    pu: 'Query Only Subordinate Branches'
  },
  adjustSiteName: {
    zh: '被调整网点',
    en: '',
    pu: 'Agências Ajustadas'
  },
  adjustCount: {
    zh: '调整数量',
    en: '',
    pu: 'Ajustar Quantidade'
  },
  adjustReason: {
    zh: '调整原因',
    en: '',
    pu: 'Motivo do Ajuste'
  },
  adjustMan: {
    zh: '调整人',
    en: '',
    pu: 'Ajustador'
  },
  adjustTime: {
    zh: '调整日期',
    en: '',
    pu: 'Data do Ajuste'
  },
  vehicleNumber: {
    zh: '末端车牌号',
    en: '',
    pu: 'Número final de registo do veículo'
  },
  noPrintNumber: {
    zh: '没有需要打印的运单号',
    en: '',
    pu: 'Não há números de remessa que precisam ser impressos'
  },
  noOperator: {
    zh: '选择的订单状态不可操作',
    en: '',
    pu: 'O status do pedido selecionado não permite operações'
  },
  goodsNOfuhe: {
    zh: '商品与实际不符',
    en: '',
    pu: 'Os produtos não correspondem à realidade'
  },
  stopTime: {
    zh: '请选择截止时间',
    en: '',
    pu: 'Por favor, selecione a data limite'
  },
  infoError: {
    zh: '收件人信息错误,无法核实',
    en: '',
    pu: 'As informações do destinatário estão erradas e não podem ser verificadas'
  },
  fixTime: {
    zh: '修改截止时间',
    en: '',
    pu: 'Alterar prazo'
  },
  receiveMsgType: {
    zh: '消息接收类型',
    en: '',
    pu: 'Tipo de recepção de mensagens'
  },
  receiveMsgType00: {
    zh: '编织袋回收消息',
    en: '',
    pu: 'Mensagem de reciclagem de sacos tecidos'
  },
  notExport1000: {
    zh: '单次导出不能超过1000条数据',
    en: '',
    pu: 'A exportação única não pode exceder 1000 registros de dados'
  },
  exportPicture: {
    zh: '导出图片',
    en: '',
    pu: 'Exportar imagens'
  },
  UploadUser: {
    zh: '上传用户',
    en: 'Upload User',
    pu: 'Usuário de upload'
  },
  PaymentCertificate: {
    zh: '支付凭证',
    en: 'Payment Certificate',
    pu: 'Certificado de pagamento'
  },
  AnjunFinancialAuditDetails: {
    zh: '安骏财务审核详情',
    en: 'Anjun Financial Audit Details',
    pu: 'Detalhes da auditoria financeira do Anjun'
  },
  FinancialAudit: {
    zh: '财务审核',
    en: 'Financial Audit',
    pu: 'Auditoria financeira'
  },
  AuditUser: {
    zh: '审核用户',
    en: 'Audit User',
    pu: 'Usuário de auditoria'
  },
  AuditResultCannotBeEmpty: {
    zh: '审核结果不能为空',
    en: 'Audit result cannot be empty',
    pu: 'O resultado da auditoria não pode estar vazio'
  },
  PleaseConfirmThatThePayment: {
    zh: '请确认客户的支付金额与应付金额是否一致',
    en: 'Please confirm that the payment amount of the customer is consistent with the amount to be paid',
    pu: 'Por favor, confirme se o valor de pagamento do cliente é consistente com o valor a ser pago'
  },
  auditPassed: {
    zh: '支付金额一致，审核通过',
    en: 'Payment amount consistent, audit passed',
    pu: 'O valor de pagamento é consistente, auditoria passada'
  },
  auditNotPassed: {
    zh: '支付金额不一致，审核不通过',
    en: 'Payment amount inconsistent, audit not passed',
    pu: 'O valor de pagamento é inconsistente, auditoria não passada'
  },
  AuditRemarkCannotBeEmpty: {
    zh: '审核备注不能为空',
    en: 'Audit remark cannot be empty',
    pu: 'As observações de auditoria não podem estar vazias'
  },
  PleaseEnterARemark: {
    zh: '请输入备注',
    en: 'Please enter a remark',
    pu: 'Por favor, insira uma observação'
  },
  fixResult: {
    zh: '修改状态或结果',
    en: '',
    pu: 'Alterar status ou resultado'
  },
  moreTimeNotReply: {
    zh: '超时未回复',
    en: '',
    pu: 'Nenhuma resposta devido ao tempo limite'
  },
  ScanninTip0313: {
    zh: '该功能用于盘点滞留在网点的包裹以产生新的轨迹',
    en: 'This feature is used to inventory packages滞留 at the branch to generate new tracking events',
    pu: 'Este recurso serve para inventariar pacotes retidos na agência e gerar novos eventos de rastreamento'
  },
  scanWaybillOrBagNumber: {
    zh: '扫描运单号或袋号',
    en: 'Scan Waybill or Bag Number',
    pu: 'Escanear Número de Rastreamento ou Número da Sacola'
  },
  lastScannedTrackingOrBag: {
    zh: '最新扫描运单号或袋号',
    en: 'Last Scanned Tracking/Bag Number',
    pu: 'Último Número de Rastreamento/Sacola Escaneado'
  },
  inputOrScanner: {
    zh: '请扫描或输入',
    en: '',
    pu: 'Favor digitalizar ou digitar'
  },
  storagePartsScanning: {
    zh: '移除出袋',
    en: 'Remove the bag',
    pu: 'Retire o saco'
  },
  advancedSearch: {
    zh: '高级搜索',
    en: 'Advanced Search',
    pu: 'Mais filtros'
  },
  selectDropdownData: {
    zh: '请选择下拉框数据',
    en: 'Please select dropdown data',
    pu: 'Por favor selecione os dados do menu suspenso'
  },
  selectSameComplaintType: {
    zh: '请选择相同的投诉类型',
    en: 'Please select the same complaint type',
    pu: 'Por favor selecione o mesmo tipo de reclamação'
  },
  modifyStatus: {
    zh: '修改状态',
    en: 'Modify Status',
    pu: 'Modificar Status'
  },
  modifyResult: {
    zh: '修改结果',
    en: 'Modify Result',
    pu: 'Modificar Resultado'
  },
  onDutyRegistration: {
    zh: '上岗人数登记',
    en: 'On-Duty Personnel Registration',
    pu: 'Registro de Pessoal em Serviço'
  },
  position: {
    zh: '岗位',
    en: 'Position',
    pu: 'Cargo/Função'
  },
  onDutyDate: {
    zh: '上岗日期',
    en: 'On-Duty Date',
    pu: 'Data de Início no Serviço'
  },
  onDutyCount: {
    zh: '上岗人数',
    en: 'Number of On-Duty Personnel',
    pu: 'Número de Pessoal em Serviço'
  },
  enterValidNumber: {
    zh: '请输入有效的数字',
    en: 'Please enter a valid number',
    pu: 'Por favor insira um número válido'
  },
  selectPosition: {
    zh: '选择岗位',
    en: 'Select Position',
    pu: 'Selecionar Cargo'
  },
  collection: {
    zh: '揽收',
    en: 'Collection',
    pu: 'Coleta'
  },
  sorting: {
    zh: '分拣',
    en: 'Sorting',
    pu: 'Triagem'
  },
  transportation: {
    zh: '运输',
    en: 'Transportation',
    pu: 'Transporte'
  },
  funcFavorites: {
    zh: '功能收藏夹',
    en: 'Function Favorites',
    pu: 'Funcionalidades favoritos'
  },
  selectMenu: {
    zh: '选择菜单',
    en: 'Select Menu',
    pu: 'Selecionar Menu'
  },
  setFavorites: {
    zh: '设置收藏夹',
    en: 'Set Favorites',
    pu: 'Configurar Favoritos'
  },
  pinToTop: {
    zh: '置顶',
    en: 'Pin to Top',
    pu: 'Fixar no Topo'
  },
  batchReview: {
    zh: '批量审核',
    en: 'Batch Review',
    pu: 'Revisão em Lote'
  },
  reviewResult: {
    zh: '审核结果',
    en: 'Review Result',
    pu: 'Resultado da Revisão'
  },
  returnInflowHub: {
    zh: '返还/流入网点',
    en: 'Return/Inflow Hub',
    pu: 'Centro de Devolução/Entrada'
  },
  recycleOutflowHub: {
    zh: '回收/流出网点',
    en: 'Recycle/Outflow Hub',
    pu: 'Centro de Reciclagem/Saída'
  },
  returnDataQuery: {
    zh: '返回数据查询',
    en: 'Return Data Query',
    pu: 'Consulta de Dados de Devolução'
  },
  recycleDataQuery: {
    zh: '回收数据查询',
    en: 'Recycle Data Query',
    pu: 'Consulta de Dados de Reciclagem'
  },
  inflowSummary: {
    zh: '流入汇总',
    en: 'Inflow Summary',
    pu: 'Resumo de Entrada'
  },
  outflowSummary: {
    zh: '流出汇总',
    en: 'Outflow Summary',
    pu: 'Resumo de Saída'
  },
  returnStatus: {
    zh: '返还状态',
    en: 'Return Status',
    pu: 'Status de Devolução'
  },
  recycled: {
    zh: '已回收',
    en: 'Recycled',
    pu: 'Reciclado'
  },
  notRecycledTotal: {
    zh: '未回收总数',
    en: 'Not Recycled Total',
    pu: 'Total Não Reciclado'
  },
  notRecycled: {
    zh: '未回收',
    en: 'Not Recycled',
    pu: 'Não Reciclado'
  },
  pendingConfirmation: {
    zh: '待确认',
    en: 'Pending Confirmation',
    pu: 'Pendente'
  },
  returned: {
    zh: '已返还',
    en: 'Returned',
    pu: 'Devolvido'
  },
  notReturned: {
    zh: '未返还',
    en: 'Not Returned',
    pu: 'Não Devolvido'
  },
  notReturnedTotal: {
    zh: '未返还总数',
    en: 'Not Returned Total',
    pu: 'Total Não Devolvido'
  },
  greaterThanZeroMax999: {
    zh: '输入大于0, 最大999',
    en: 'Enter a number greater than 0, maximum 999',
    pu: 'Insira um número maior que 0, máximo 999'
  },
  keepThreeDecimals: {
    zh: '保留三位小数',
    en: 'Keep three decimal places',
    pu: 'Manter três casas decimais'
  },
  greaterThanZeroMax500: {
    zh: '输入大于0, 最大500',
    en: 'Enter a number greater than 0, maximum 500',
    pu: 'Insira um número maior que 0, máximo 500'
  },
  trackingNode: {
    zh: '轨迹节点',
    en: 'Tracking Node',
    pu: 'Nó de Rastreamento'
  },
  trackingNodeCode: {
    zh: '轨迹节点代码',
    en: 'Tracking Node Code',
    pu: 'Código do Nó de Rastreamento'
  },
  numericCode: {
    zh: '数字代码',
    en: 'Numeric Code',
    pu: 'Código Numérico'
  },
  chineseDescription: {
    zh: '中文描述',
    en: 'Chinese Description',
    pu: 'Descrição em Chinês'
  },
  portugueseDescription: {
    zh: '葡语描述',
    en: 'Portuguese Description',
    pu: 'Descrição em Português'
  },
  isPublic: {
    zh: '是否对外',
    en: 'Is Public',
    pu: 'É Público'
  },
  publicChineseDescription: {
    zh: '对外-中文描述',
    en: 'Public Chinese Description',
    pu: 'Descrição Pública em Chinês'
  },
  publicPortugueseDescription: {
    zh: '对外-葡语描述',
    en: 'Public Portuguese Description',
    pu: 'Descrição Pública em Português'
  },
  AddHoliday: {
    zh: '新增节假日',
    en: 'Add Holiday',
    pu: 'Adicionar Feriado'
  },
  HolidayName: {
    zh: '假期名称',
    en: 'Holiday Name',
    pu: 'Nome do feriado'
  },
  Days: {
    zh: '天数',
    en: 'Days',
    pu: 'Dias'
  },
  HolidayType: {
    zh: '假期类型',
    en: 'Holiday Type',
    pu: 'Tipo de feriado'
  },
  StateOrCity: {
    zh: '州或城市',
    en: 'State or City',
    pu: 'Estado ou cidade'
  },
  LatestModificationTime: {
    zh: '最新修改时间',
    en: 'Latest Modification Time',
    pu: 'Última alteração por'
  },
  LatestModifier: {
    zh: '最新修改人',
    en: 'Latest Modifier',
    pu: 'Última atualização'
  },
  serialNumber: {
    zh: '序号',
    en: 'number',
    pu: 'Número'
  },
  EditHoliday: {
    zh: '编辑节假日',
    en: 'Edit Holiday',
    pu: 'Editar feriado'
  },
  SelectStateCity: {
    zh: '选择州或城市',
    en: 'Select State or City',
    pu: 'Selecionar Estado ou Cidade'
  },
  SelectMerchant: {
    zh: '选择商户',
    en: 'Select Merchant',
    pu: 'Selecionar Comerciante'
  },
  NationalHoliday: {
    zh: '全国假期',
    en: 'National Holiday',
    pu: 'Feriado Nacional'
  },
  LocalHoliday: {
    zh: '地方假期',
    en: 'Local Holiday',
    pu: 'Feriado Local'
  },
  RefreshHistoricalData: {
    zh: '刷新历史数据',
    en: 'Refresh Historical Data',
    pu: 'Atualizar Dados Históricos'
  },
  nfeInvoiceNumber: {
    zh: 'NFE发票号',
    en: 'NFE Invoice Number',
    pu: 'Número da Nota Fiscal NFE'
  },
  nfeInvoiceKey: {
    zh: 'NFE发票密钥',
    en: 'NFE Invoice Key',
    pu: 'Chave da Nota Fiscal NFE'
  },
  timeRangeLimit7Days: {
    zh: '时间范围不能超过7天，请重新选择！',
    en: 'Time range cannot exceed 7 days, please select again!',
    pu: 'O intervalo de tempo não pode exceder 7 dias, por favor selecione novamente!'
  },
  max20: {
    zh: '最多20个',
    en: 'Maximum 20',
    pu: 'Máximo 20'
  },
  aiAudit: {
    zh: 'AI审核',
    en: 'AI Audit',
    pu: 'Auditoria por IA'
  },
  aiAuditUnreviewed: {
    zh: '未审',
    en: 'Not Audited',
    pu: 'Não auditado'
  },
  aiAuditReviewed: {
    zh: '已审',
    en: 'Audited',
    pu: 'Auditado'
  },
  aiAuditExempt: {
    zh: '免审',
    en: 'Exempt from Audit',
    pu: 'Isento de auditoria'
  },
  announcementCenter: {
    zh: '公告中心',
    en: 'Announcement Center',
    pu: 'Centro de Anúncios'
  },
  appDownloadMethod: {
    zh: 'APP获取方式',
    en: 'App Download Method',
    pu: 'Método de Download do App'
  },
  scanOrLinkDownload: {
    zh: '扫码下载或链接下载 > 复制链接',
    en: 'Scan to download or link download > Copy link',
    pu: 'Escanear para baixar ou baixar por link > Copiar link'
  },
  searchAppStore: {
    zh: '可在 App Store搜索 Anjun Express 进行下载',
    en: "Search 'Anjun Express' on the App Store to download",
    pu: "Pesquise 'Anjun Express' na App Store para baixar"
  },
  noDownloadLink: {
    zh: '当前暂无下载链接',
    en: 'No download link available',
    pu: 'Nenhum link de download disponível'
  },
  copied: {
    zh: '已复制',
    en: 'Copied',
    pu: 'Copiado'
  },
  importantReminder: {
    zh: '重要提醒',
    en: 'Important Reminder',
    pu: 'Lembrete Importante'
  },
  viewNow: {
    zh: '立即查看',
    en: 'View Now',
    pu: 'Visualizar Agora'
  },
  // 系统消息配置列表
  systemMessageConfigList: {
    zh: '系统消息配置列表',
    en: 'System Message Configuration List',
    pu: 'Lista de Configuração de Mensagens do Sistema'
  },
  systemMessageDesc: {
    zh: '统一管理系统公告、登录弹框、重要提醒横幅和公告卡片。',
    en: 'Unified management of system announcements, login popups, important reminder banners and announcement cards.',
    pu: 'Gerenciamento unificado de anúncios do sistema, popups de login, banners de lembretes importantes e cartões de anúncio.'
  },
  createSystemMessage: {
    zh: '新建系统消息',
    en: 'Create System Message',
    pu: 'Criar Mensagem do Sistema'
  },
  exportList: {
    zh: '导出列表',
    en: 'Export List',
    pu: 'Exportar Lista'
  },
  reset: {
    zh: '重置',
    en: 'Reset',
    pu: 'Redefinir'
  },
  search: {
    zh: '查询',
    en: 'Search',
    pu: 'Pesquisar'
  },
  creationTime: {
    zh: '创建时间',
    en: 'Creation Time',
    pu: 'Data de Criação'
  },
  startTime: {
    zh: '开始时间',
    en: 'Start Time',
    pu: 'Data de Início'
  },
  endTime: {
    zh: '结束时间',
    en: 'End Time',
    pu: 'Data de Término'
  },
  messageType: {
    zh: '公告类型',
    en: 'Announcement Type',
    pu: 'Tipo de Anúncio'
  },
  title: {
    zh: '标题',
    en: 'Title',
    pu: 'Título'
  },
  status: {
    zh: '状态',
    en: 'Status',
    pu: 'Status'
  },
  system: {
    zh: '系统',
    en: 'System',
    pu: 'Sistema'
  },
  receiveArea: {
    zh: '接收大区',
    en: 'Receive Area',
    pu: 'Área de Recebimento'
  },
  receiveState: {
    zh: '接收州',
    en: 'Receive State',
    pu: 'Estado de Recebimento'
  },
  receiveSite: {
    zh: '接收网点',
    en: 'Receive Site',
    pu: 'Local de Recebimento'
  },
  receiveUser: {
    zh: '接收用户',
    en: 'Receive User',
    pu: 'Usuário de Recebimento'
  },
  creator: {
    zh: '创建人',
    en: 'Creator',
    pu: 'Criador'
  },
  pleaseSelect: {
    zh: '请选择',
    en: 'Please select',
    pu: 'Por favor selecione'
  },
  pleaseChoose: {
    zh: '请选择',
    en: 'Please choose',
    pu: 'Por favor escolha'
  },
  all: {
    zh: '全部',
    en: 'All',
    pu: 'Todos'
  },
  allSystems: {
    zh: '全部系统',
    en: 'All Systems',
    pu: 'Todos os Sistemas'
  },
  inputTitleKeyword: {
    zh: '请输入标题关键词',
    en: 'Please enter title keyword',
    pu: 'Por favor insira a palavra-chave do título'
  },
  selectArea: {
    zh: '选择大区',
    en: 'Select area',
    pu: 'Selecionar área'
  },
  selectState: {
    zh: '请选择州',
    en: 'Please select state',
    pu: 'Por favor selecione o estado'
  },
  selectSite: {
    zh: '选择网点',
    en: 'Select site',
    pu: 'Selecionar local'
  },
  selectUserAccount: {
    zh: '选择用户账号',
    en: 'Select user account',
    pu: 'Selecionar conta de usuário'
  },
  urgentAnnouncement: {
    zh: '紧急公告',
    en: 'Urgent Announcement',
    pu: 'Anúncio Urgente'
  },
  operationNotice: {
    zh: '运营通知',
    en: 'Operation Notice',
    pu: 'Aviso de Operação'
  },
  systemUpdate: {
    zh: '系统更新',
    en: 'System Update',
    pu: 'Atualização do Sistema'
  },
  normalNotice: {
    zh: '普通通知',
    en: 'Normal Notice',
    pu: 'Aviso Normal'
  },
  pendingPublish: {
    zh: '待发布',
    en: 'Pending Publish',
    pu: 'Aguardando Publicação'
  },
  enabled: {
    zh: '启用中',
    en: 'Enabled',
    pu: 'Ativado'
  },
  disabled: {
    zh: '已停用',
    en: 'Disabled',
    pu: 'Desativado'
  },
  draft: {
    zh: '草稿',
    en: 'Draft',
    pu: 'Rascunho'
  },
  expressSystem: {
    zh: '快递系统',
    en: 'Express System',
    pu: 'Sistema Expresso'
  },
  providerSystem: {
    zh: '服务商系统',
    en: 'Provider System',
    pu: 'Sistema do Provedor'
  },
  totalConfigs: {
    zh: '共',
    en: 'Total',
    pu: 'Total'
  },
  configsUnit: {
    zh: '条配置',
    en: 'configs',
    pu: 'configurações'
  },
  view: {
    zh: '查看',
    en: 'View',
    pu: 'Ver'
  },
  edit: {
    zh: '编辑',
    en: 'Edit',
    pu: 'Editar'
  },
  disable: {
    zh: '停用',
    en: 'Disable',
    pu: 'Desativar'
  },
  enable: {
    zh: '启用',
    en: 'Enable',
    pu: 'Ativar'
  },
  displayPosition: {
    zh: '展示位置',
    en: 'Display Position',
    pu: 'Posição de Exibição'
  },
  userEnd: {
    zh: '用户端',
    en: 'User End',
    pu: 'Terminal do Usuário'
  },
  userRange: {
    zh: '用户范围',
    en: 'User Range',
    pu: 'Alcance do Usuário'
  },
  receiveAreaCount: {
    zh: '接收大区',
    en: 'Receive Area',
    pu: 'Área de Recebimento'
  },
  receiveStateCount: {
    zh: '接收州',
    en: 'Receive State',
    pu: 'Estado de Recebimento'
  },
  receiveSiteCount: {
    zh: '接收网点',
    en: 'Receive Site',
    pu: 'Local de Recebimento'
  },
  receiveUserCount: {
    zh: '接收用户',
    en: 'Receive User',
    pu: 'Usuário de Recebimento'
  },
  publishTime: {
    zh: '发布时间',
    en: 'Publish Time',
    pu: 'Data de Publicação'
  },
  operation: {
    zh: '操作',
    en: 'Operation',
    pu: 'Operação'
  },
  confirmDisable: {
    zh: '确定要停用该消息吗？',
    en: 'Are you sure you want to disable this message?',
    pu: 'Tem certeza que deseja desativar esta mensagem?'
  },
  confirmEnable: {
    zh: '确定要启用该消息吗？',
    en: 'Are you sure you want to enable this message?',
    pu: 'Tem certeza que deseja ativar esta mensagem?'
  },
  tips: {
    zh: '提示',
    en: 'Tips',
    pu: 'Dicas'
  },
  confirm: {
    zh: '是',
    en: 'Yes',
    pu: 'Sim'
  },
  cancel: {
    zh: '否',
    en: 'No',
    pu: 'Não'
  },
  operationSuccess: {
    zh: '操作成功',
    en: 'Operation successful',
    pu: 'Operação bem-sucedida'
  },
  currentStatusNotSupport: {
    zh: '该消息当前状态不支持此操作',
    en: 'The current status of this message does not support this operation',
    pu: 'O status atual desta mensagem não suporta esta operação'
  },
  chinese: {
    zh: '中文',
    en: 'Chinese',
    pu: 'Chinês'
  },
  portuguese: {
    zh: '葡语',
    en: 'Portuguese',
    pu: 'Português'
  },
  // ... 之前已有的内容 ...

  // ========== 系统消息表单页面 ==========
  // 页面标题
  publishSystemMessage: {
    zh: '发布系统消息',
    en: 'Publish System Message',
    pu: 'Publicar Mensagem do Sistema'
  },
  publishSystemMessageDesc: {
    zh: '配置公告内容、展示位置、弹框规则和发布时间。',
    en: 'Configure announcement content, display position, popup rules and publish time.',
    pu: 'Configure o conteúdo do anúncio, posição de exibição, regras de popup e horário de publicação.'
  },
  backToMessageList: {
    zh: '返回消息列表',
    en: 'Back to Message List',
    pu: 'Voltar à Lista de Mensagens'
  },

  // 面板标题
  basicInfoSection: {
    zh: '一、公告基础信息',
    en: 'I. Basic Announcement Information',
    pu: 'I. Informações Básicas do Anúncio'
  },
  notificationRulesSection: {
    zh: '二、通知规则',
    en: 'II. Notification Rules',
    pu: 'II. Regras de Notificação'
  },
  publishTimeSection: {
    zh: '三、发布时间',
    en: 'III. Publish Time',
    pu: 'III. Horário de Publicação'
  },

  // 表单标签
  titleChinese: {
    zh: '标题（中文）',
    en: 'Title (Chinese)',
    pu: 'Título (Chinês)'
  },
  titlePortuguese: {
    zh: '标题（葡语）',
    en: 'Title (Portuguese)',
    pu: 'Título (Português)'
  },
  abstractChinese: {
    zh: '摘要（中文）',
    en: 'Abstract (Chinese)',
    pu: 'Resumo (Chinês)'
  },
  abstractPortuguese: {
    zh: '摘要（葡语）',
    en: 'Abstract (Portuguese)',
    pu: 'Resumo (Português)'
  },
  contentChinese: {
    zh: '正文（中文）',
    en: 'Content (Chinese)',
    pu: 'Conteúdo (Chinês)'
  },
  contentPortuguese: {
    zh: '正文（葡语）',
    en: 'Content (Portuguese)',
    pu: 'Conteúdo (Português)'
  },
  image: {
    zh: '图片',
    en: 'Image',
    pu: 'Imagem'
  },
  popupCloseMethod: {
    zh: '弹框关闭方式',
    en: 'Popup Close Method',
    pu: 'Método de Fechamento do Popup'
  },
  publishMethod: {
    zh: '发布方式',
    en: 'Publish Method',
    pu: 'Método de Publicação'
  },
  isTop: {
    zh: '是否置顶',
    en: 'Is Top',
    pu: 'Fixar no Topo'
  },
  effectiveTime: {
    zh: '生效时间',
    en: 'Effective Time',
    pu: 'Data de Início'
  },
  expirationTime: {
    zh: '失效时间',
    en: 'Expiration Time',
    pu: 'Data de Expiração'
  },

  // 输入占位符
  pleaseInput: {
    zh: '请输入',
    en: 'Please input',
    pu: 'Por favor insira'
  },
  selectEffectiveTime: {
    zh: '选择生效时间',
    en: 'Select effective time',
    pu: 'Selecionar data de início'
  },
  selectExpirationTime: {
    zh: '选择失效时间',
    en: 'Select expiration time',
    pu: 'Selecionar data de expiração'
  },

  // 图片上传
  uploadMessageImage: {
    zh: '上传消息图片',
    en: 'Upload Message Image',
    pu: 'Carregar Imagem da Mensagem'
  },
  uploadImageDesc: {
    zh: '非必填。支持 JPG / PNG，建议尺寸 1200 × 420。用于公告卡片和弹框内容展示。',
    en: 'Optional. Support JPG / PNG, recommended size 1200 × 420. Used for announcement cards and popup content display.',
    pu: 'Opcional. Suporta JPG / PNG, tamanho recomendado 1200 × 420. Usado para cartões de anúncio e exibição de conteúdo popup.'
  },
  selectImage: {
    zh: '选择图片',
    en: 'Select Image',
    pu: 'Selecionar Imagem'
  },
  changeImage: {
    zh: '更换图片',
    en: 'Change Image',
    pu: 'Alterar Imagem'
  },
  imagePreviewArea: {
    zh: '图片预览区域',
    en: 'Image Preview Area',
    pu: 'Área de Pré-visualização da Imagem'
  },
  uploadSuccess: {
    zh: '图片上传成功',
    en: 'Image uploaded successfully',
    pu: 'Imagem carregada com sucesso'
  },
  uploadFailed: {
    zh: '图片上传失败，请重试',
    en: 'Image upload failed, please try again',
    pu: 'Falha ao carregar imagem, por favor tente novamente'
  },
  onlyImageAllowed: {
    zh: '只能上传图片文件！',
    en: 'Only image files can be uploaded!',
    pu: 'Apenas arquivos de imagem podem ser carregados!'
  },
  imageSizeLimit: {
    zh: '图片大小不能超过 10MB！',
    en: 'Image size cannot exceed 10MB!',
    pu: 'O tamanho da imagem não pode exceder 10MB!'
  },

  // 规则说明
  ruleDescription: {
    zh: '规则说明：只有当展示位置选择「登录弹框」时，才需要配置「用户端」「接收用户」「弹框关闭方式」。如果只选择「重要提醒横幅」或「公告卡片」，则不需要配置弹框相关字段。',
    en: 'Rule Description: Only when the display position selects "Login Popup", you need to configure "User End", "Receive User", and "Popup Close Method". If only "Important Reminder Banner" or "Announcement Card" is selected, no popup-related fields need to be configured.',
    pu: 'Descrição da Regra: Somente quando a posição de exibição selecionar "Popup de Login", você precisa configurar "Terminal do Usuário", "Usuário de Recebimento" e "Método de Fechamento do Popup". Se apenas "Banner de Lembrete Importante" ou "Cartão de Anúncio" for selecionado, nenhum campo relacionado ao popup precisa ser configurado.'
  },
  loginPopupRule: {
    zh: '登录弹框规则',
    en: 'Login Popup Rules',
    pu: 'Regras do Popup de Login'
  },

  // 展示位置选项
  loginPopup: {
    zh: '登录弹框',
    en: 'Login Popup',
    pu: 'Popup de Login'
  },
  importantReminderBanner: {
    zh: '重要提醒横幅',
    en: 'Important Reminder Banner',
    pu: 'Banner de Lembrete Importante'
  },
  announcementCard: {
    zh: '公告卡片',
    en: 'Announcement Card',
    pu: 'Cartão de Anúncio'
  },

  // 用户端选项
  pcEnd: {
    zh: 'PC端',
    en: 'PC End',
    pu: 'Terminal PC'
  },
  appEnd: {
    zh: 'APP端',
    en: 'APP End',
    pu: 'Terminal APP'
  },

  // 弹框关闭方式选项
  directlyClose: {
    zh: '可直接关闭',
    en: 'Can close directly',
    pu: 'Pode fechar diretamente'
  },
  closeAfter10Seconds: {
    zh: '10秒后可关闭',
    en: 'Can close after 10 seconds',
    pu: 'Pode fechar após 10 segundos'
  },
  closeAfter20Seconds: {
    zh: '20秒后可关闭',
    en: 'Can close after 20 seconds',
    pu: 'Pode fechar após 20 segundos'
  },
  closeAfter30Seconds: {
    zh: '30秒后可关闭',
    en: 'Can close after 30 seconds',
    pu: 'Pode fechar após 30 segundos'
  },
  closeAfter60Seconds: {
    zh: '60秒后可关闭',
    en: 'Can close after 60 seconds',
    pu: 'Pode fechar após 60 segundos'
  },

  // 接收用户选项
  allUsers: {
    zh: '全部用户',
    en: 'All Users',
    pu: 'Todos os Usuários'
  },
  specifiedArea: {
    zh: '指定大区',
    en: 'Specified Area',
    pu: 'Área Especificada'
  },
  specifiedState: {
    zh: '指定州',
    en: 'Specified State',
    pu: 'Estado Especificado'
  },
  specifiedSite: {
    zh: '指定网点',
    en: 'Specified Site',
    pu: 'Local Especificado'
  },
  specifiedUser: {
    zh: '指定用户',
    en: 'Specified User',
    pu: 'Usuário Especificado'
  },

  // 发布方式选项
  publishImmediately: {
    zh: '立即发布',
    en: 'Publish Immediately',
    pu: 'Publicar Imediatamente'
  },
  scheduledPublish: {
    zh: '定时发布',
    en: 'Scheduled Publish',
    pu: 'Publicação Programada'
  },

  // 置顶选项
  top: {
    zh: '置顶',
    en: 'Top',
    pu: 'Fixar no Topo'
  },
  notTop: {
    zh: '不置顶',
    en: 'Not Top',
    pu: 'Não Fixar'
  },
  saveDraft: {
    zh: '保存草稿',
    en: 'Save Draft',
    pu: 'Salvar Rascunho'
  },
  submitPublish: {
    zh: '提交发布',
    en: 'Submit Publish',
    pu: 'Enviar Publicação'
  },

  // 校验消息
  pleaseSelectMsgType: {
    zh: '请选择公告类型',
    en: 'Please select announcement type',
    pu: 'Por favor selecione o tipo de anúncio'
  },
  pleaseInputChineseTitle: {
    zh: '请输入标题（中文）',
    en: 'Please input title (Chinese)',
    pu: 'Por favor insira o título (Chinês)'
  },
  pleaseInputPortugueseTitle: {
    zh: '请输入标题（葡语）',
    en: 'Please input title (Portuguese)',
    pu: 'Por favor insira o título (Português)'
  },
  pleaseInputChineseContent: {
    zh: '请输入正文（中文）',
    en: 'Please input content (Chinese)',
    pu: 'Por favor insira o conteúdo (Chinês)'
  },
  pleaseInputPortugueseContent: {
    zh: '请输入正文（葡语）',
    en: 'Please input content (Portuguese)',
    pu: 'Por favor insira o conteúdo (Português)'
  },
  pleaseSelectSystem: {
    zh: '请选择系统',
    en: 'Please select system',
    pu: 'Por favor selecione o sistema'
  },
  pleaseSelectDisplayPosition: {
    zh: '请选择展示位置',
    en: 'Please select display position',
    pu: 'Por favor selecione a posição de exibição'
  },
  pleaseSelectPublishMethod: {
    zh: '请选择发布方式',
    en: 'Please select publish method',
    pu: 'Por favor selecione o método de publicação'
  },
  pleaseSelectTopType: {
    zh: '请选择是否置顶',
    en: 'Please select top type',
    pu: 'Por favor selecione se deseja fixar no topo'
  },
  pleaseSelectUserEnd: {
    zh: '请选择用户端',
    en: 'Please select user end',
    pu: 'Por favor selecione o terminal do usuário'
  },
  scheduledPublishNeedTime: {
    zh: '定时发布请选择生效时间',
    en: 'Please select effective time for scheduled publish',
    pu: 'Por favor selecione a data de início para publicação programada'
  },
  failureTimeMustGreater: {
    zh: '失效时间必须大于生效时间',
    en: 'Expiration time must be greater than effective time',
    pu: 'A data de expiração deve ser maior que a data de início'
  },
  pleaseSelectArea: {
    zh: '请选择大区',
    en: 'Please select area',
    pu: 'Por favor selecione a área'
  },
  pleaseSelectState2: {
    zh: '请选择州',
    en: 'Please select state',
    pu: 'Por favor selecione o estado'
  },
  pleaseSelectSite: {
    zh: '请选择网点',
    en: 'Please select site',
    pu: 'Por favor selecione o local'
  },
  pleaseSelectUser: {
    zh: '请选择用户',
    en: 'Please select user',
    pu: 'Por favor selecione o usuário'
  },
  maxSelect20: {
    zh: '最多一次选 20 个',
    en: 'Maximum 20 selections at once',
    pu: 'Máximo de 20 seleções por vez'
  },

  // 操作提示
  saveDraftSuccess: {
    zh: '保存草稿成功',
    en: 'Draft saved successfully',
    pu: 'Rascunho salvo com sucesso'
  },
  saveDraftFailed: {
    zh: '保存草稿失败，请重试',
    en: 'Failed to save draft, please try again',
    pu: 'Falha ao salvar rascunho, por favor tente novamente'
  },
  publishSuccess: {
    zh: '发布成功',
    en: 'Published successfully',
    pu: 'Publicado com sucesso'
  },
  publishFailed: {
    zh: '发布失败，请重试',
    en: 'Publish failed, please try again',
    pu: 'Falha ao publicar, por favor tente novamente'
  },
  queryDetailFailed: {
    zh: '查询消息详情失败',
    en: 'Failed to query message details',
    pu: 'Falha ao consultar detalhes da mensagem'
  },
  queryDetailFailedRetry: {
    zh: '查询消息详情失败，请重试',
    en: 'Failed to query message details, please try again',
    pu: 'Falha ao consultar detalhes da mensagem, por favor tente novamente'
  },
  submitPublishConfirm: {
    zh: '确定要提交发布该公告吗？发布后用户端将收到该消息。',
    en: 'Are you sure you want to submit and publish this announcement? Users will receive this message after publishing.',
    pu: 'Tem certeza que deseja enviar e publicar este anúncio? Os usuários receberão esta mensagem após a publicação.'
  },
  submitPublishConfirmTitle: {
    zh: '提交发布确认',
    en: 'Submit Publish Confirmation',
    pu: 'Confirmação de Envio de Publicação'
  },
  confirmPublish: {
    zh: '确定发布',
    en: 'Confirm Publish',
    pu: 'Confirmar Publicação'
  },
  // ===== 强制签收审核弹框（审核工作台）=====
  signReview: {
    zh: '签收审核',
    en: 'Signature Review',
    pu: 'Auditoria de Assinatura'
  },
  pendingReview: {
    zh: '待审核',
    en: 'Pending Review',
    pu: 'Pendente de revisão'
  },
  reviewPackage: {
    zh: '审核包裹',
    en: 'Review Package',
    pu: 'Pacote de auditoria'
  },
  prevOne: {
    zh: '上一个',
    en: 'Previous',
    pu: 'Anterior'
  },
  nextOne: {
    zh: '下一个',
    en: 'Next',
    pu: 'Próximo'
  },
  confirmAndNext: {
    zh: '确定并进入下一个',
    en: 'Confirm and go to next',
    pu: 'Confirmar e ir para o próximo'
  },
  autoEnterNext: {
    zh: '审核后自动进入下一个',
    en: 'Automatically go to the next after review',
    pu: 'Entrar automaticamente no próximo após a revisão'
  },
  failReason: {
    zh: '不通过原因',
    en: 'Reason for rejection',
    pu: 'Motivo da reprovação'
  },
  photoFailDesc: {
    zh: '照片不清晰、照片不完整等',
    en: 'Photo unclear, incomplete, etc.',
    pu: 'Foto pouco clara, incompleta, etc.'
  },
  signFailDesc: {
    zh: '签名缺失、签名不清晰等',
    en: 'Signature missing, unclear, etc.',
    pu: 'Assinatura ausente, pouco clara, etc.'
  },
  recipient: {
    zh: '收件人',
    en: 'Recipient',
    pu: 'Destinatário'
  },
  contactPhone: {
    zh: '联系电话',
    en: 'Contact phone',
    pu: 'Telefone de contato'
  },
  customer: {
    zh: '客户',
    en: 'Customer',
    pu: 'Cliente'
  },
  merchant: {
    zh: '商户',
    en: 'Merchant',
    pu: 'Comerciante'
  },
  reviewedTag: {
    zh: '已审核',
    en: 'Reviewed',
    pu: 'Auditado'
  }
};
export { home };
